exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date .label[data-v-2a27e173] {\n  pointer-events: none;\n  overflow: hidden;\n  position: absolute;\n  height: 26px;\n  line-height: 26px;\n  transition: 0.3s;\n  z-index: 1;\n  font-size: 14px;\n  color: #41566c;\n  padding: 0 12px;\n  top: -21px;\n  left: 0;\n  z-index: 5;\n}", ""]);

// exports
